import React from "react";

class DateOnlyInput extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            readonly: false,
        }
    }

    _onFocus = () => {
        this.props.openOnFocus && this.props.openOnFocus();
        this.setState({
            readonly: true,
        });
    };

    _onBlur = () => {
        this.setState({
            readonly: false,
        });
    };

    render() {
        const { onBlur, onFocus, inputRef, openOnFocus, ...rest } = this.props;
    
        return (
            <input
                ref={inputRef}
                onBlur={this._onBlur}
                onFocus={this._onFocus}
                type="text"
                readOnly={this.state.readonly}
                {...rest}
            />
        );
    }
}

export default DateOnlyInput;
